import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { MessageScreen } from "../../common/MessageScreen";
import { GidSettingsRoutes } from "./GidSettingsRoutes";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@inject("externalInterfaceStore")
export class GidSettingsDeleteSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("sidentitySettings.deleteDevice.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="sidentitySettings.deleteDevice.success.message" />}
                buttonLabelId="common.close"
                onDismiss={() => pushRoute(GidSettingsRoutes.ROOT)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsDeleteSuccess.tsx